import { MaterialInput } from 'app/components/material'
import { IQuestionsGroupProps, QuestionsGroup } from 'app/components/questions/base';
import * as _ from 'lodash';
import * as React from 'react'
import { Alert, Button, Col, Row, Tab, Tabs, Well } from 'react-bootstrap'
import MaterialNumber from 'app/components/material/MaterialNumber';
import { RadioGroup } from 'app/components/form/RadioGroup';

type TabTitleGetter = (tab: any) => string

interface ITabbedQuestionProps extends IQuestionsGroupProps {
  headerDescription: string
  tabTitle: string | TabTitleGetter
  tabTitleDefault: string
  pathToArray?: string
}

interface ITab {
  hidden: boolean
}

interface ITabbedQuestionState {
  activeKey: number
  tabs: ITab[]
}

interface IReactChildElementProps {
  children?: React.ReactNode
  name?: string
}

interface IReactChildElement extends React.ReactElement<IReactChildElementProps> {
  name?: string
  value?: string
  type: React.ComponentClass<IReactChildElementProps>
}

class TabbedQuestion extends QuestionsGroup<ITabbedQuestionProps, ITabbedQuestionState> {
  state: ITabbedQuestionState = {
    activeKey: 0,
    tabs: []
  }

  componentWillMount() {
    this.initTabs()
  }

  initTabs() {
    let index = 0

    while (true) {
      const indexed = this.props.pathToArray.replace('[i]', `[${index}]`)
      const value = this.getValueForQuestion(indexed)

      if (value) {
        this.state.tabs.push({ hidden: false })
        index++
      } else {
        break
      }
    }

    if (this.state.tabs.length <= 0) {
      this.state.tabs.push({ hidden: false })
    }

    this.setState({ tabs: this.state.tabs })
  }

  handleSelect(activeKey: number) {
    const { tabs } = this.state

    if (activeKey === tabs.length) {
      tabs.push({ hidden: false })
      activeKey = tabs.length - 1

      this.setState({ tabs })
    }

    this.setState({ activeKey })
  }

  hideTab(index: number) {
    let { activeKey } = this.state
    const { tabs } = this.state
    const tab = tabs[index]

    if (tab) {
      tab.hidden = true

      if (activeKey === index) {
        activeKey = tabs.findIndex((t) => !t.hidden)
      }

      this.setState({ tabs, activeKey })
    }
  }

  findAndUpdateInputs = (childAny: any, index: number) => {
    const child: IReactChildElement = childAny
    const isMaterialInput = child.type && (child.type.displayName === 'MaterialInput' || child.type.displayName === 'MaterialNumber' || child.type === MaterialInput || child.type === MaterialNumber)
    const isRadioGroup = child.type && (child.type.displayName === 'RadioGroup' || child.type.displayName === 'RadioGroup' || child.type === RadioGroup || child.type === RadioGroup)
    const hasChildren = child.props && child.props.children
    const forceRemoveValue = this.state.tabs[index].hidden

    if (isMaterialInput || isRadioGroup) {
      if (child.props.name) {
        const name = child.props.name.replace('[i]', `[${index}]`)
        const defaultValue = this.getValueForQuestion(name)
        const selectedValue = defaultValue
        // tslint:disable-next-line:no-console
        console.log('name: ' + name + ', selectedValue: ' + selectedValue)

        return React.cloneElement(childAny, { defaultValue, selectedValue, name, forceRemoveValue })
      }
    } else if (hasChildren) {
      const children = React.Children.map(child.props.children,
        (child2: React.ReactElement<any>) => this.findAndUpdateInputs(child2, index)
      )

      return React.cloneElement(childAny, { children })
    }

    return child
  }

  getTabTitle(index: number) {
    const tab = this.state.tabs[index]
    let title: string
    if (_.isFunction(this.props.tabTitle)) {
      const indexed = this.props.pathToArray.replace('[i]', `[${index}]`)
      const value = this.getValueForQuestion(indexed)
      title = this.props.tabTitle(value)
    } else {
      title = `${this.props.tabTitle} #${index + 1}`
    }

    if (tab.hidden) {
      title += ' Deleted'
    }

    return title
  }

  render() {
    return (
      <section>
        <header className="animated fadeIn">
          {this.props.icon ?
            <i className={this.props.icon} /> : null
          }
          <span>{this.props.header}</span>
        </header>

        <article className="animated fadeIn" >
          {this.props.headerDescription ?
            <h4 className="lead">{this.props.headerDescription}</h4> : null
          }

          <Tabs id="tabbed" bsStyle="tabs" activeKey={this.state.activeKey} onSelect={(activeKey) => this.handleSelect(activeKey)}>
            {this.state.tabs.map((tab, index) => (
              <Tab key={index} eventKey={index} title={this.getTabTitle(index)} disabled={tab.hidden}>
                <section>
                  {...React.Children.map(this.props.children,
                    (child: React.ReactElement<any>) => this.findAndUpdateInputs(child, index)
                  )}

                  <footer>
                    <a className="btn btn-link" onClick={() => this.hideTab(index)}>
                      Remove {this.getTabTitle(index)}
                    </a>
                  </footer>
                </section>
              </Tab>
            ))}
            <Tab eventKey={this.state.tabs.length} title={`+ Add ${this.props.tabTitleDefault}`} />
          </Tabs>
        </article>

      </section >
    )
  }
}

export {
  TabbedQuestion
}



// WEBPACK FOOTER //
// ./src/app/components/questions/tabbed/index.tsx